















































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import {createApiKeys, deleteApiKeys, getApiKeys} from "@/modules/account/service";
import {LIMIT_PAGE_DEFAULT, PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {PaginationMeta} from "@/interfaces/common";
import {debounce} from "lodash";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import {LadingStore} from "@/modules/ladings/store";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "id",
        width: 20,
        ellipsis: true
    },
    {
        title: "Ngày tạo",
        dataIndex: "createdDate",
        key: "createdDate",
        width: 100,
        ellipsis: true
    },
    {
        title: "Api Key",
        dataIndex: "tokenKey",
        key: "tokenKey",
        width: 200,
        ellipsis: true
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        width: 100,
        scopedSlots: { customRender: "status" },
        ellipsis: true
    },
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "action",
        width: 100,
        scopedSlots: { customRender: "action" },
        align: 'center',
        ellipsis: true
    },
]

const params = {
    page: 1,
    limit: LIMIT_PAGE_DEFAULT,
    search: undefined
}
@Component({
    name: "ApiKey",
    components: {CommonStatusLabel}
})
export default class extends mixins(CommonMixin) {
    apiKeys = [] as any;
    columns = [...columns];
    params = { ...params } as any;
    meta: PaginationMeta = new PaginationMeta();
    activeKey = ""
    baseApi = process.env.VUE_APP_BASE_URL

    created() {
        this.getApiKeys(this.params);
    }

    async getApiKeys(params: any) {
        try {
            const { data } = await getApiKeys(params);
            this.apiKeys = data.datas?.map((data: any, index: number) => ({ ...data, stt: index + 1, children: undefined }));
            this.meta = data.meta;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }

    get pagination() {
        return {
            current: this.meta.page,
            pageSize: this.meta.limit,
            total: this.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} api key`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        this.getApiKeys({...this.params, page: pagination.current, limit: pagination.pageSize});
    }

    @Watch("params", { deep: true })
    onChangeParams(val: any) {
        this.handleChangeParams(val, this);
    }

    handleChangeParams = debounce((val: any, vm) => {
        vm.getApiKeys({...val, page: 1});
    }, 500)

    async createApiKey() {
        this.$confirm({
            title: 'Bạn muốn tạo api key ?',
            onOk: async () => {
                try {
                    const { data } = await createApiKeys()
                    this.$message.success("Tạo api key thành công");
                    this.getApiKeys({...this.params})
                } catch (e) {
                    this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
                }
            },
            cancelText: "Hủy",
            okText: "Đồng ý"
        });
    }

    async onConfirm(id) {
        try {
            const { data } = await deleteApiKeys(id)
            this.$message.success("Xóa api key thành công");
            this.apiKeys = this.apiKeys.filter(item => item.id != id);
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }
}
